var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import Card from '@material-ui/core/Card';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import { Tooltip, Warning as WarningIcon } from '../';
var useStyles = makeStyles(function (theme) {
  return {
    container: {
      backgroundColor: theme.palette.secondary.dark,
      boxShadow: 'none',
      padding: theme.spacing(2),
      width: '100%'
    },
    title: _extends({
      padding: 0
    }, R.pathOr({}, ['mixins', 'share', 'title'], theme)),
    content: {
      padding: theme.spacing(1, 0),
      '&:last-child': {
        padding: theme.spacing(1, 0)
      }
    },
    label: theme.typography.body2,
    warning: _extends({
      marginLeft: theme.spacing(0.5),
      width: 'unset',
      fontSize: 'inherit',
      height: '1.3em'
    }, R.pathOr({}, ['mixins', 'share', 'warning'], theme))
  };
});
var Warning = function Warning(_ref) {
  var title = _ref.title;
  var classes = useStyles();
  var theme = useTheme();
  var warningColor = R.path(['palette', 'highlight', 'hl1'], theme) || theme.palette.primary.dark;
  var warningTextColor = theme.palette.getContrastText(warningColor);
  return React.createElement(Tooltip, {
    className: classes.warning,
    title: title,
    tabIndex: 0,
    variant: 'warning',
    'aria-hidden': false,
    placement: 'bottom',
    PopperProps: {
      modifiers: {
        flip: {
          behavior: ['bottom', 'top', 'left', 'right']
        }
      }
    }
  }, React.createElement(WarningIcon, {
    pathBackgroundColor: warningColor,
    pathColor: warningTextColor
  }));
};
Warning.propTypes = process.env.NODE_ENV !== "production" ? {
  title: PropTypes.string
} : {};
var Mode = function Mode(_ref2) {
  var changeMode = _ref2.changeMode,
    mode = _ref2.mode,
    _ref2$modes = _ref2.modes,
    modes = _ref2$modes === undefined ? [] : _ref2$modes,
    title = _ref2.title;
  var classes = useStyles();
  return React.createElement(Card, {
    className: classes.container
  }, React.createElement(CardContent, {
    className: classes.content
  }, React.createElement(Typography, {
    variant: 'h6',
    className: classes.title
  }, title), React.createElement(RadioGroup, {
    onChange: function onChange(e) {
      return changeMode(e.target.value);
    },
    value: mode
  }, R.map(function (_ref3) {
    var label = _ref3.label,
      value = _ref3.value,
      _ref3$disabled = _ref3.disabled,
      disabled = _ref3$disabled === undefined ? false : _ref3$disabled,
      warningMessage = _ref3.warningMessage;
    return React.createElement(FormControlLabel, {
      classes: {
        label: classes.label
      },
      key: value,
      disabled: disabled,
      control: React.createElement(Radio, {
        variant: 'outlined',
        color: 'primary'
      }),
      label: React.createElement('span', null, label, warningMessage && React.createElement(Warning, {
        title: warningMessage
      })),
      value: value
    });
  })(modes))));
};
Mode.propTypes = process.env.NODE_ENV !== "production" ? {
  changeMode: PropTypes.func,
  mode: PropTypes.string,
  modes: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    value: PropTypes.string,
    warningMessage: PropTypes.string,
    disabled: PropTypes.bool
  })),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
} : {};
export default Mode;